import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";

const firebaseConfig = {
  apiKey: __FIREBASE_APIKEY__,
  authDomain: __FIREBASE_AUTHDOMAIN__,
  projectId: __FIREBASE_PROJECTID__,
  storageBucket: __FIREBASE_STORAGEBUCKET__,
  messagingSenderId: __FIREBASE_MESSAGINGSENDERID__,
  appId: __FIREBASE_APPID__,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

if (__ENV__ === "local") {
  // see https://firebase.google.com/docs/emulator-suite/connect_auth#web
  connectAuthEmulator(auth, "http://127.0.0.1:9099");
}
